// extracted by mini-css-extract-plugin
module.exports = {"linkWithIcon":"linkWithIcon_linkWithIcon__ZzsO0"};